import {Deserializable} from './deserializable';
import {BaseModel} from './baseModel';


export class EmailData extends BaseModel implements Deserializable {

  fromEmail: string;
  fromName: string;
  toEmail: string;
  ccEmail: string;
  replyToEmail: string;
  subject: string;
  message: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
